<div mat-dialog-title>
  <svg-icon icon="x-button" class="modal-close-button" mat-dialog-close [attr.data-automation-id]="'genesys-proactive-email-close-modal'"></svg-icon>
  <h2 cdkFocusInitial class="create-email-title">{{ 'genesysProactiveEmailModal.createEmail' | translate }}</h2>
</div>
<form [formGroup]="proactiveEmailForm" (ngSubmit)="onCreateEmailConversation()">
  <div mat-dialog-content>
    <mat-form-field class="modal-queue-input form-group" color="primary" appearance="outline">
      <mat-label>{{ 'genesysProactiveEmailModal.searchQueue' | translate }}</mat-label>
      <mat-error
        *ngIf="queueRequiredError"
        [attr.data-automation-id]="'genesys-proactive-email-queue-input-error'">{{ 'genesysProactiveEmailModal.queueRequiredError' | translate }}</mat-error>
      <input type="text"
             formControlName="queue"
             required
             aria-label="Queue"
             matInput
             [matAutocomplete]="auto"
             [attr.data-automation-id]="'genesys-proactive-email-queue-input'">
      <span matPrefix>
        <svg-icon icon="magnifying-glass"></svg-icon>
      </span>
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayOption">
        <mat-option *ngFor="let queue of filteredQueues$ | async" [value]="queue" [attr.data-automation-id]="'genesys-proactive-email-queue-item'">
          {{ queue.name }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field class="modal-dropdown-toggle form-group" color="primary" appearance="outline">
      <mat-label>{{ 'genesysProactiveEmailModal.recipients' | translate }}</mat-label>
      <mat-chip-list formControlName="recipients" #chipList>
        <mat-chip *ngFor="let email of recipients.value" (removed)="removeEmail(email)" [attr.data-automation-id]="'genesys-proactive-email-recipient-item'">
          <div class="email-container">
            {{ email }}
          </div>
          <button matChipRemove [attr.data-automation-id]="'genesys-proactive-email-remove-recipient'">
            <i class="fa fa-times" aria-hidden="true"></i>
          </button>
        </mat-chip>
      </mat-chip-list>
      <input type="text"
             placeholder="{{ 'genesysProactiveEmailModal.addRecipients' | translate }}"
             formControlName="recipientsInput"
             matInput
             [attr.data-automation-id]="'genesys-proactive-email-recipients-input'"
             [matChipInputFor]="chipList"
             [matChipInputSeparatorKeyCodes]="separatorKeyCodes"
             [matChipInputAddOnBlur]="true"
             (matChipInputTokenEnd)="addEmail($event)">
      <mat-error
        *ngIf="recipientsRequiredError"
        [attr.data-automation-id]="'genesys-proactive-email-recipients-input-error'">{{ 'genesysProactiveEmailModal.fieldEmptyError' | translate }}</mat-error>
    </mat-form-field>
    <div *ngIf="createConversationFailed$|async" class="error-message">
      {{ 'genesysProactiveEmailModal.createEmailConversationError' | translate }}
    </div>
</div>
<div mat-dialog-actions [align]="'end'">
  <button mat-flat-button
          type="submit"
          color="primary"
          [disabled]="isSubmitButtonDisabled$|async"
          [attr.data-automation-id]="'genesys-proactive-email-submit'">
          {{ 'genesysProactiveEmailModal.continue' | translate }}
  </button>
</div>
</form>
